import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=f0d07cfa&scoped=true&"
import script from "./CustomerItem.vue?vue&type=script&lang=ts&"
export * from "./CustomerItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerItem.vue?vue&type=style&index=0&id=f0d07cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d07cfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d07cfa')) {
      api.createRecord('f0d07cfa', component.options)
    } else {
      api.reload('f0d07cfa', component.options)
    }
    module.hot.accept("./CustomerItem.vue?vue&type=template&id=f0d07cfa&scoped=true&", function () {
      api.rerender('f0d07cfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apartment/components/CustomerItem.vue"
export default component.exports